export const formatRegPlate = (regPlate: string): string | null => {
  if (!regPlate) return null;

  // Supprime les espaces et met en majuscules
  let formatted = regPlate.replace(/\s/g, '').toUpperCase();

  // Vérifie si la plaque est au format FNI (ancien format)
  const fniFmt = /^[0-9]{2,4}[A-Z]{2,3}[0-9]{2}$/;
  if (fniFmt.test(formatted)) {
    return formatted;
  }

  // Vérifie si la plaque est au format SIV (nouveau format)
  const sivFmt = /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/;
  if (sivFmt.test(formatted)) {
    return formatted;
  }

  return formatted;
};
